module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/ts-loader/index.js??ruleSet[1].rules[2].use[0]!./unit-price-history.ts"));
	}, "forms/unit-price-history/unit-price-history");
}